import React, { forwardRef } from 'react';

import { isElementOfType } from '../../utilities/components';

import WpButton from '../button/WpButton';

import './WpDropdownToggle.scss';

export interface Props {
  children?: React.ReactNode;
  onClick?: Function;
  disabled?: boolean;
}

const WpDropdownToggle = forwardRef(function ({ children, onClick, disabled = false }: Props, ref: any) {
  const childrenLength = React.Children.count(children);
  const isToggleButton = children && childrenLength === 1 && isElementOfType(children, WpButton);

  const handleClickAction = () => {
    onClick();
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleClickAction();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleClickAction();
    }
  };

  return (
    <>
      {isToggleButton ? (
        React.Children.map(children, (child: React.ReactElement<any>) => {
          return React.cloneElement(child, { onClick: handleClick, ref, disabled });
        })
      ) : (
        <div
          className="WpDropdownToggle"
          onClick={handleClick}
          ref={ref}
          role="button"
          tabIndex={0}
          onKeyDown={handleKeyDown}
        >
          {children}
        </div>
      )}
    </>
  );
});

export default WpDropdownToggle;
